import React from "react";
import tash_logo from "../../../../icons/trash.png";
import edit_logo from "../../../../icons/edit.png";

/**
 * Tr Component
 * Table row for individual distro preset
 */
const Tr = ({
  item,
  order,
  onEdit,
  onDelete,
  isAllowedToEditOrDelete,
  reddevcut,
}) => {
  const handleEdit = () => {
    if (!isAllowedToEditOrDelete) return;

    onEdit({
      id: item.distro_preset_id,
      preset_name: item.preset_name,
      preset_order: item.preset_order,
      beneficiary_distro: Number(item.beneficiary_distro),
      sponsor_distro: Number(item.sponsor_distro),
      seller_distro: Number(item.seller_distro),
      artist_distro: item.artist_distro,
    });
  };

  const handleDelete = () => {
    if (!isAllowedToEditOrDelete) return;

    onDelete({
      id: item.distro_preset_id,
      preset_name: item.preset_name || "",
      delete: true,
    });
  };

  return (
    <tr>
      <td className="first-col col-numeric-date">{order + 1}</td>
      <td className="col-numeric-date">{item.preset_name}</td>
      <td className="col-numeric-date">{item.beneficiary_distro}%</td>
      <td className="col-numeric-date">{item.sponsor_distro - reddevcut}%</td>
      <td className="col-numeric-date">{item.artist_distro - reddevcut}%</td>
      <td className="col-options">
        <button
          type="button"
          onClick={handleEdit}
          className="btn-icon"
          aria-label="Edit preset"
          disabled={!isAllowedToEditOrDelete}
          style={{
            background: "none",
            border: "none",
            padding: 0,
            cursor: isAllowedToEditOrDelete ? "pointer" : "not-allowed",
          }}
        >
          <img className="edit-delete-icons" src={edit_logo} alt="Edit" />
        </button>
        &nbsp;
        {order !== 0 && (
          <button
            type="button"
            onClick={handleDelete}
            className="btn-icon"
            aria-label="Delete preset"
            disabled={!isAllowedToEditOrDelete}
            style={{
              background: "none",
              border: "none",
              padding: 0,
              cursor: isAllowedToEditOrDelete ? "pointer" : "not-allowed",
            }}
          >
            <img
              className="edit-delete-icons ms-3"
              src={tash_logo}
              alt="Delete"
            />
          </button>
        )}
      </td>
    </tr>
  );
};

export default Tr;
